(function () {
    function initPLPInPageNavigation() {
        const root = document.querySelector('.plp');
        if (!root) return;

        root.addEventListener('click', function (event) {
            const link = event.target.closest('a[href^="#"]');
            if (!link || !root.contains(link)) return;

            const hash = link.getAttribute('href');
            if (!hash || hash === '#') return;

            const targetId = decodeURIComponent(hash.slice(1));
            const target = document.getElementById(targetId);
            if (!target) return;

            event.preventDefault();

            const header = root.querySelector('.plp-header');
            const headerHeight = header ? header.getBoundingClientRect().height : 0;
            const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({
                top: Math.max(0, targetTop),
                behavior: reduceMotion ? 'auto' : 'smooth'
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPLPInPageNavigation, { once: true });
    } else {
        initPLPInPageNavigation();
    }
})();

(function () {
    function initPLPHeaderNavigation() {
        const root = document.querySelector('.plp');
        if (!root) return;

        const header = root.querySelector('.plp-header');
        const wrapper = header && header.querySelector('.plp-header__wrapper');
        const nav = header && header.querySelector('.plp-header__nav');
        if (!header || !wrapper || !nav) return;

        if (!nav.id) nav.id = 'plp-header-nav';

        const button = document.createElement('button');
        button.className = 'plp-header__menu-button';
        button.type = 'button';
        button.setAttribute('aria-label', 'メニューを開く');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', nav.id);
        button.innerHTML = `
            <span class="plp-header__menu-line"></span>
            <span class="plp-header__menu-line"></span>
            <span class="plp-header__menu-line"></span>
        `;
        wrapper.appendChild(button);

        const desktopMedia = window.matchMedia('(min-width: 768px)');

        function setOpen(open) {
            const isDesktop = desktopMedia.matches;
            const shouldOpen = !isDesktop && open;

            button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
            button.setAttribute('aria-label', shouldOpen ? 'メニューを閉じる' : 'メニューを開く');
            nav.classList.toggle('plp-header__nav--open', shouldOpen);
            nav.setAttribute('aria-hidden', isDesktop || shouldOpen ? 'false' : 'true');
        }

        button.addEventListener('click', function () {
            setOpen(button.getAttribute('aria-expanded') !== 'true');
        });

        nav.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                setOpen(false);
            });
        });

        document.addEventListener('click', function (event) {
            if (desktopMedia.matches) return;
            if (!header.contains(event.target)) setOpen(false);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') setOpen(false);
        });

        function syncViewport() {
            setOpen(false);
        }

        if (typeof desktopMedia.addEventListener === 'function') {
            desktopMedia.addEventListener('change', syncViewport);
        } else if (typeof desktopMedia.addListener === 'function') {
            desktopMedia.addListener(syncViewport);
        }

        syncViewport();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPLPHeaderNavigation, { once: true });
    } else {
        initPLPHeaderNavigation();
    }
})();

// ===== PLP shared lightbox =====
(function () {
    function initPLPLightbox() {
        if (window.__PLP_LIGHTBOX_INITIALIZED) return;

        const root = document.querySelector('.plp');
        if (!root) return;

        const items = Array.from(root.querySelectorAll('[data-plp-enlargeable]'));
        if (!items.length) return;

        window.__PLP_LIGHTBOX_INITIALIZED = true;

        const lightbox = document.createElement('div');
        lightbox.className = 'plp-lightbox';
        lightbox.setAttribute('aria-hidden', 'true');
        lightbox.innerHTML = `
            <button class="plp-lightbox__close" type="button" aria-label="閉じる">×</button>
            <button class="plp-lightbox__prev" type="button" aria-label="前の画像">‹</button>
            <div class="plp-lightbox__content"></div>
            <button class="plp-lightbox__next" type="button" aria-label="次の画像">›</button>
            <p class="plp-lightbox__help">画像はホイール・ピンチで拡大できます</p>
        `;
        root.appendChild(lightbox);

        const content = lightbox.querySelector('.plp-lightbox__content');
        const closeButton = lightbox.querySelector('.plp-lightbox__close');
        const prevButton = lightbox.querySelector('.plp-lightbox__prev');
        const nextButton = lightbox.querySelector('.plp-lightbox__next');

        let currentIndex = 0;
        let target = null;
        let scale = 1;
        let x = 0;
        let y = 0;
        let startX = 0;
        let startY = 0;
        let dragging = false;
        let pinchStartDistance = 0;
        let pinchStartScale = 1;
        let lastTap = 0;
        let swipeStartX = 0;
        let swipeStartY = 0;

        function updateTransform() {
            if (!target) return;
            if (scale <= 1) {
                scale = 1;
                x = 0;
                y = 0;
            }
            target.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${scale})`;
        }

        function resetZoom() {
            scale = 1;
            x = 0;
            y = 0;
            if (target) {
                target.style.transition = 'transform 0.2s ease';
                updateTransform();
                window.setTimeout(function () {
                    if (target) target.style.transition = 'none';
                }, 220);
            }
        }

        function sourceImage(item) {
            return item.tagName === 'IMG' ? item : item.querySelector('img');
        }

        function load(index) {
            if (index < 0 || index >= items.length) return;

            const item = items[index];
            const img = sourceImage(item);
            if (!img) return;

            currentIndex = index;

            const clone = img.cloneNode(true);
            const fullSrc = item.getAttribute('data-full-src') || img.getAttribute('data-full-src');

            if (fullSrc) clone.src = fullSrc;

            clone.removeAttribute('class');
            clone.removeAttribute('id');
            clone.className = 'plp-lightbox__image';

            content.innerHTML = '';
            content.appendChild(clone);
            target = clone;

            resetZoom();

            prevButton.disabled = currentIndex === 0;
            nextButton.disabled = currentIndex === items.length - 1;
        }

        function open(index) {
            load(index);
            lightbox.classList.add('plp-lightbox--open');
            lightbox.setAttribute('aria-hidden', 'false');
            document.body.classList.add('plp-lightbox-open');
        }

        function close() {
            lightbox.classList.remove('plp-lightbox--open');
            lightbox.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('plp-lightbox-open');

            window.setTimeout(function () {
                if (!lightbox.classList.contains('plp-lightbox--open')) {
                    content.innerHTML = '';
                    target = null;
                }
            }, 250);
        }

        function prev() {
            if (currentIndex > 0) load(currentIndex - 1);
        }

        function next() {
            if (currentIndex < items.length - 1) load(currentIndex + 1);
        }

        items.forEach(function (item, index) {
            item.setAttribute('role', 'button');
            item.setAttribute('tabindex', '0');
            item.setAttribute(
                'aria-label',
                item.getAttribute('aria-label') || '画像を拡大表示'
            );

            item.addEventListener('click', function () {
                open(index);
            });

            item.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    open(index);
                }
            });
        });

        closeButton.addEventListener('click', close);

        prevButton.addEventListener('click', function (event) {
            event.stopPropagation();
            prev();
        });

        nextButton.addEventListener('click', function (event) {
            event.stopPropagation();
            next();
        });

        lightbox.addEventListener('click', function (event) {
            if (event.target === lightbox && scale === 1) close();
        });

        document.addEventListener('keydown', function (event) {
            if (!lightbox.classList.contains('plp-lightbox--open')) return;

            if (event.key === 'Escape') close();
            if (event.key === 'ArrowLeft') prev();
            if (event.key === 'ArrowRight') next();
        });

        content.addEventListener('wheel', function (event) {
            if (!target) return;

            event.preventDefault();

            scale = Math.min(
                4.5,
                Math.max(1, scale + (event.deltaY < 0 ? 0.3 : -0.3))
            );

            updateTransform();
        }, { passive: false });

        content.addEventListener('mousedown', function (event) {
            if (!target || scale <= 1) return;

            dragging = true;
            startX = event.clientX - x;
            startY = event.clientY - y;
        });

        window.addEventListener('mousemove', function (event) {
            if (!dragging || scale <= 1) return;

            x = event.clientX - startX;
            y = event.clientY - startY;
            updateTransform();
        });

        window.addEventListener('mouseup', function () {
            dragging = false;
        });

        content.addEventListener('touchstart', function (event) {
            if (!target) return;

            if (event.touches.length === 2) {
                pinchStartDistance = Math.hypot(
                    event.touches[0].pageX - event.touches[1].pageX,
                    event.touches[0].pageY - event.touches[1].pageY
                );

                pinchStartScale = scale;
                dragging = false;
                return;
            }

            if (event.touches.length === 1) {
                const now = Date.now();

                if (now - lastTap < 300) {
                    event.preventDefault();
                    scale = scale > 1 ? 1 : 2.5;
                    updateTransform();
                    lastTap = 0;
                    return;
                }

                lastTap = now;
                dragging = true;

                startX = event.touches[0].clientX - x;
                startY = event.touches[0].clientY - y;

                swipeStartX = event.touches[0].clientX;
                swipeStartY = event.touches[0].clientY;
            }
        }, { passive: false });

        content.addEventListener('touchmove', function (event) {
            if (!target) return;

            if (event.touches.length === 2) {
                event.preventDefault();

                const distance = Math.hypot(
                    event.touches[0].pageX - event.touches[1].pageX,
                    event.touches[0].pageY - event.touches[1].pageY
                );

                if (pinchStartDistance) {
                    scale = Math.min(
                        4.5,
                        Math.max(1, pinchStartScale * distance / pinchStartDistance)
                    );
                    updateTransform();
                }

                return;
            }

            if (event.touches.length === 1 && dragging && scale > 1) {
                event.preventDefault();

                x = event.touches[0].clientX - startX;
                y = event.touches[0].clientY - startY;
                updateTransform();
            }
        }, { passive: false });

        content.addEventListener('touchend', function (event) {
            if (event.touches.length < 2) pinchStartDistance = 0;

            if (!event.touches.length && dragging) {
                dragging = false;

                if (scale === 1 && event.changedTouches.length) {
                    const dx = event.changedTouches[0].clientX - swipeStartX;
                    const dy = event.changedTouches[0].clientY - swipeStartY;

                    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
                        if (dx < 0) next();
                        else prev();
                    }
                }
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPLPLightbox, { once: true });
    } else {
        initPLPLightbox();
    }
})();


// ===== PLP shared hero slideshow =====
(function () {
    function initPLPHeroSlideshow() {
        if (window.__PLP_HERO_INITIALIZED) return;

        const root = document.querySelector('.plp');
        if (!root) return;

        const slidesConfig = window.PLP_HERO_SLIDES;
        const container = root.querySelector('#hero-slideshow');

        if (!container || !Array.isArray(slidesConfig) || slidesConfig.length === 0) return;

        window.__PLP_HERO_INITIALIZED = true;

        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const FADE_DURATION = 1.5;
        const FADE_MS = FADE_DURATION * 1000;

        function getSlideSettings(slide) {
            return {
                src: isMobile && slide.spSrc ? slide.spSrc : slide.src,
                duration: isMobile && slide.spDuration ? slide.spDuration : (slide.duration || 6),
                position: isMobile && slide.spPosition ? slide.spPosition : (slide.position || 'center'),
                move: isMobile && slide.spMove ? slide.spMove : (slide.move || 'zoom-in')
            };
        }

        function imageExists(url) {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = url;
            });
        }

        async function buildHeroSlideshow() {
            const settings = slidesConfig.map(getSlideSettings);
            const checks = await Promise.all(settings.map((slide) => imageExists(slide.src)));
            const validSlides = settings.filter((_, index) => checks[index]);

            if (!validSlides.length) {
                console.warn('表示可能なheroスライド画像が見つかりませんでした。');
                return;
            }

            const moveMap = {
                'zoom-in': ['scale(1)', 'scale(1.12)'],
                'zoom-out': ['scale(1.12)', 'scale(1)'],
                'move-left': ['scale(1.08) translateX(3%)', 'scale(1.08) translateX(-3%)'],
                'move-right': ['scale(1.08) translateX(-3%)', 'scale(1.08) translateX(3%)'],
                'move-up': ['scale(1.08) translateY(3%)', 'scale(1.08) translateY(-3%)'],
                'move-up-h': ['scale(1.08) translateY(20%)', 'scale(1.08) translateY(-20%)'],
                'move-down': ['scale(1.08) translateY(-3%)', 'scale(1.08) translateY(3%)'],
                'pan-up': ['scale(1.08) translateY(2%)', 'scale(1.08) translateY(-2%)'],
                'pan-down': ['scale(1.08) translateY(-2%)', 'scale(1.08) translateY(2%)'],
                'pan-left': ['scale(1.08) translateX(2%)', 'scale(1.08) translateX(-2%)'],
                'pan-right': ['scale(1.08) translateX(-2%)', 'scale(1.08) translateX(2%)']
            };

            const elements = validSlides.map((slide) => {
                const el = document.createElement('div');
                el.className = `plp-hero-slide plp-hero-slide--${String(slide.move).replace(/[^a-z0-9-]/gi, '').toLowerCase()}`;
                el.style.backgroundImage = `url("${slide.src.replace(/"/g, '\\"')}")`;
                el.style.backgroundPosition = slide.position;
                el.style.opacity = '0';
                el.style.animation = 'none';
                container.appendChild(el);
                return el;
            });

            let currentIndex = 0;
            let moveAnimation = null;
            let fadeOutTimer = 0;
            let nextTimer = 0;

            function clearSlideTimers() {
                window.clearTimeout(fadeOutTimer);
                window.clearTimeout(nextTimer);
            }

            function playSlide(index) {
                clearSlideTimers();

                const slide = validSlides[index];
                const el = elements[index];
                const move = moveMap[String(slide.move).toLowerCase()] || moveMap['zoom-in'];
                const durationMs = Math.max(FADE_MS * 2, slide.duration * 1000);
                const fadeOutDelay = Math.max(0, durationMs - FADE_MS);

                elements.forEach((item, itemIndex) => {
                    if (itemIndex !== index) item.style.opacity = '0';
                });

                if (moveAnimation) {
                    moveAnimation.cancel();
                    moveAnimation = null;
                }

                el.style.transform = move[0];

                moveAnimation = el.animate(
                    [
                        { transform: move[0] },
                        { transform: move[1] }
                    ],
                    {
                        duration: durationMs,
                        easing: 'linear',
                        fill: 'forwards'
                    }
                );

                const isFirstReveal = index === 0 && currentIndex === 0 && !container.dataset.plpHeroRevealed;

                if (isFirstReveal) {
                    container.dataset.plpHeroRevealed = 'true';
                    el.style.transitionDuration = '2.4s';

                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            window.setTimeout(() => {
                                el.style.opacity = '1';

                                window.setTimeout(() => {
                                    el.style.transitionDuration = `${FADE_DURATION}s`;
                                }, 2500);
                            }, 120);
                        });
                    });
                } else {
                    el.style.transitionDuration = `${FADE_DURATION}s`;
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            el.style.opacity = '1';
                        });
                    });
                }

                fadeOutTimer = window.setTimeout(() => {
                    el.style.opacity = '0';
                }, fadeOutDelay);

                nextTimer = window.setTimeout(() => {
                    /* Preserve the final transform while the slide is invisible. */
                    el.style.transform = move[1];
                    if (moveAnimation) {
                        moveAnimation.cancel();
                        moveAnimation = null;
                    }

                    currentIndex = (index + 1) % validSlides.length;
                    playSlide(currentIndex);
                }, durationMs);
            }

            playSlide(currentIndex);
        }

        buildHeroSlideshow();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPLPHeroSlideshow, { once: true });
    } else {
        initPLPHeroSlideshow();
    }
})();



// ===== PLP shared pan visual =====
(function () {
    function initPLPPanVisuals() {
        const root = document.querySelector('.plp');
        if (!root) return;

        const visuals = Array.from(root.querySelectorAll('.plp-pan-visual'));
        if (!visuals.length) return;

        const slidesConfig = window.PLP_HERO_SLIDES;
        const mobileMedia = window.matchMedia('(max-width: 767px)');

        function getImageSource(visual) {
            const isMobile = mobileMedia.matches;

            // Explicit image URLs take priority over hero-slide reuse.
            const customPc = visual.getAttribute('data-plp-pan-image');
            const customSp = visual.getAttribute('data-plp-pan-image-sp');

            if (isMobile && customSp) return customSp;
            if (customPc) return customPc;

            const index = Number.parseInt(
                visual.getAttribute('data-plp-hero-slide'),
                10
            );

            if (
                !Array.isArray(slidesConfig) ||
                Number.isNaN(index) ||
                !slidesConfig[index]
            ) {
                return '';
            }

            const slide = slidesConfig[index];
            return isMobile && slide.spSrc ? slide.spSrc : (slide.src || '');
        }

        function renderVisual(visual) {
            const src = getImageSource(visual);
            let fixed = visual.querySelector('.plp-pan-visual__fixed');

            if (!fixed) {
                fixed = document.createElement('div');
                fixed.className = 'plp-pan-visual__fixed';
                fixed.setAttribute('aria-hidden', 'true');
                visual.appendChild(fixed);
            }

            if (!src) {
                fixed.style.backgroundImage = 'none';
                return;
            }

            fixed.style.backgroundImage = `url("${src.replace(/"/g, '\\"')}")`;
        }

        function renderAll() {
            visuals.forEach(renderVisual);
        }

        if (typeof mobileMedia.addEventListener === 'function') {
            mobileMedia.addEventListener('change', renderAll);
        } else if (typeof mobileMedia.addListener === 'function') {
            mobileMedia.addListener(renderAll);
        }

        renderAll();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPLPPanVisuals, { once: true });
    } else {
        initPLPPanVisuals();
    }
})();

(function () {
  "use strict";

  function initPlpContactAccordion() {
    var root = document.querySelector(".plp");
    if (!root) return;

    var triggers = root.querySelectorAll(".js-plp-store-accordion");
    if (!triggers.length) return;

    triggers.forEach(function (accordionTrigger) {
      var controlsId = accordionTrigger.getAttribute("aria-controls");
      var panel = controlsId ? document.getElementById(controlsId) : null;
      if (!panel) return;

      panel.style.height = "0px";

      accordionTrigger.addEventListener("click", function () {
        var isOpen = accordionTrigger.getAttribute("aria-expanded") === "true";
        var willOpen = !isOpen;

        accordionTrigger.setAttribute("aria-expanded", String(willOpen));
        panel.setAttribute("aria-hidden", String(!willOpen));

        if (willOpen) {
          panel.classList.add("is-open");
          panel.style.height = panel.scrollHeight + "px";

          var onOpenEnd = function (event) {
            if (event.propertyName !== "height") return;
            panel.style.height = "auto";
            panel.removeEventListener("transitionend", onOpenEnd);
          };

          panel.addEventListener("transitionend", onOpenEnd);
        } else {
          panel.style.height = panel.scrollHeight + "px";
          panel.offsetHeight;
          panel.style.height = "0px";
          panel.classList.remove("is-open");
        }
      });
    });

    window.addEventListener("resize", function () {
      triggers.forEach(function (accordionTrigger) {
        var controlsId = accordionTrigger.getAttribute("aria-controls");
        var panel = controlsId ? document.getElementById(controlsId) : null;
        if (!panel) return;

        if (accordionTrigger.getAttribute("aria-expanded") === "true") {
          panel.style.height = "auto";
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPlpContactAccordion, { once: true });
  } else {
    initPlpContactAccordion();
  }
})();


document.addEventListener("DOMContentLoaded", function () {
  const footerTarget = document.getElementById("plp-footer-nav");

  if (!footerTarget) return;

  footerTarget.innerHTML = `
    <dl class="plp-footer__list">
      <dt class="plp-footer__list_title">
        <a href="/pages/premium-top">H PREMIUM/LIVE-ing TOP</a>
      </dt>

      <dd class="plp-footer__list_body">

        <dl class="plp-footer__list_h-premium">
          <dt class="plp-footer__list_h-premium__title">
            <a
              href="/pages/premium-top#top_h-premium"
              class="plp-footer__brand-link plp-footer__brand-link--h-premium"
            >
              <img
                class="plp-footer__brand-logo"
                src="https://cdn.shopify.com/s/files/1/0569/4459/1035/files/plp_logo_h-premium_gold.svg?v=1791265060"
                alt="H PREMIUM COLLECTION"
              >
            </a>
          </dt>

          <dd class="plp-footer__list_h-premium__body">
            <ul class="plp-footer__list_h-premium__ul">
              <li>
                <a class="plp-footer__product-link" href="/pages/hakuin">
                  <span>薄院 HAKUIN</span>
                  <span class="plp-footer__maker"> (by 隈研吾)</span>
                </a>
              </li>
              <li>
                <a class="plp-footer__product-link" href="/pages/springen">
                  <span>Springen</span>
                  <span class="plp-footer__maker"> (by 宮田亮平)</span>
                </a>
              </li>
              <li>
                <a class="plp-footer__product-link" href="/pages/ten">
                  <span>TEN</span>
                  <span class="plp-footer__maker"> (by ミヒャエル·シュナイダー)</span>
                </a>
              </li>
              <li>
                <a class="plp-footer__product-link" href="/pages/winglux">
                  <span>WING LUX</span>
                  <span class="plp-footer__maker"> (by 佐戸川 清)</span>
                </a>
              </li>
            </ul>
          </dd>
        </dl>

        <dl class="plp-footer__list_live-ing">
          <dt class="plp-footer__list_live-ing__title">
            <a
              href="/pages/premium-top#top_live-ing"
              class="plp-footer__brand-link plp-footer__brand-link--live-ing"
            >
              <img
                class="plp-footer__brand-logo"
                src="https://cdn.shopify.com/s/files/1/0569/4459/1035/files/plp_logo_liveing_gold.svg?v=1791266395"
                alt="LIVE-ing"
              >
            </a>
          </dt>

          <dd class="plp-footer__list_live-ing__body">
            <ul class="plp-footer__list_live-ing__ul">

              <li>
                <a class="plp-footer__product-link" href="/pages/hk-grandage">
                  <span>HK Grandage</span>
                  <span class="plp-footer__maker"> (by カリモク家具)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/hk-shelflex">
                  <span>HK Shelflex</span>
                  <span class="plp-footer__maker"> (by カリモク家具)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/hk-orto">
                  <span>HK ORTO</span>
                  <span class="plp-footer__maker"> (by カリモク家具)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/hk-galleria">
                  <span>HK GALLERIA</span>
                  <span class="plp-footer__maker"> (by カリモク家具)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/solidboardjust">
                  <span>SOLID BOARD JUST</span>
                  <span class="plp-footer__maker"> (by カリモク家具)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/seoto">
                  <span>SEOTO</span>
                  <span class="plp-footer__maker"> (by 飛彈産業)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/morinokotoba">
                  <span>森のことば Ⅱ</span>
                  <span class="plp-footer__maker"> (by 飛彈産業)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/marron">
                  <span>MARRON</span>
                  <span class="plp-footer__maker"> (by クリエイトファニチャー)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/tailor">
                  <span>Tailor</span>
                  <span class="plp-footer__maker"> (by クリエイトファニチャー)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/resty">
                  <span>Resty Ⅱ</span>
                  <span class="plp-footer__maker"> (by 日進木工)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/whitewood">
                  <span>WHITE WOOD Ⅱ</span>
                  <span class="plp-footer__maker"> (by 日進木工)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/acute">
                  <span>ACUTE</span>
                  <span class="plp-footer__maker"> (by シラカワ)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/rapt">
                  <span>RAPT</span>
                  <span class="plp-footer__maker"> (by シラカワ)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/tonari">
                  <span>tonari</span>
                  <span class="plp-footer__maker"> (by 大雪木工)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/mare">
                  <span>MARE</span>
                  <span class="plp-footer__maker"> (by 大雪木工)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/terra">
                  <span>TERRA</span>
                  <span class="plp-footer__maker"> (by 大雪木工)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/graff">
                  <span>GRAFF</span>
                  <span class="plp-footer__maker"> (by 柏木工)</span>
                </a>
              </li>

              <li>
                <a class="plp-footer__product-link" href="/pages/s-order-large">
                  <span>S-Order LARGE</span>
                  <span class="plp-footer__maker"> (by 柏木工)</span>
                </a>
              </li>

            </ul>
          </dd>
        </dl>

      </dd>
    </dl>

    <div class="plp-footer__corp">
      <a class="plp-footer__logo" href="/">お仏壇のはせがわ</a>
    </div>
  `;
});
// ===== PLP Philosophy story slider (LIVE-ing / SP only) =====
(function () {
    function initPLPPhilosophyStorySliders() {
        const roots = Array.from(document.querySelectorAll('[data-plp-story-slider]'));
        if (!roots.length) return;

        roots.forEach(function (root) {
            if (root.dataset.plpStorySliderInitialized === 'true') return;

            const viewport = root.querySelector('.plp-philosophy__story-viewport');
            const track = root.querySelector('.plp-philosophy__story-track');
            const slides = Array.from(root.querySelectorAll('.plp-philosophy__story-slide'));

            if (!viewport || !track || slides.length < 2) return;

            root.dataset.plpStorySliderInitialized = 'true';

            let navWrap = root.querySelector('.plp-philosophy__story-nav-wrap');
            if (!navWrap) {
                navWrap = document.createElement('div');
                navWrap.className = 'plp-philosophy__story-nav-wrap';
                root.appendChild(navWrap);
            }

            let nav = navWrap.querySelector('.plp-philosophy__story-nav');
            if (!nav) {
                nav = document.createElement('div');
                nav.className = 'plp-philosophy__story-nav';
                nav.setAttribute('aria-label', '文章ページ切り替え');
            }

            let dots = Array.from(nav.querySelectorAll('button'));
            if (dots.length !== slides.length) {
                nav.innerHTML = '';
                slides.forEach(function (_, dotIndex) {
                    const dot = document.createElement('button');
                    dot.type = 'button';
                    dot.setAttribute('aria-label', (dotIndex + 1) + 'ページ目');
                    nav.appendChild(dot);
                });
                dots = Array.from(nav.querySelectorAll('button'));
            }

            let prevButton = navWrap.querySelector('.plp-philosophy__story-arrow--prev');
            if (!prevButton) {
                prevButton = document.createElement('button');
                prevButton.type = 'button';
                prevButton.className = 'plp-philosophy__story-arrow plp-philosophy__story-arrow--prev';
                prevButton.setAttribute('aria-label', '前の文章へ');
            }

            let nextButton = navWrap.querySelector('.plp-philosophy__story-arrow--next');
            if (!nextButton) {
                nextButton = document.createElement('button');
                nextButton.type = 'button';
                nextButton.className = 'plp-philosophy__story-arrow plp-philosophy__story-arrow--next';
                nextButton.setAttribute('aria-label', '次の文章へ');
            }

            navWrap.appendChild(prevButton);
            navWrap.appendChild(nav);
            navWrap.appendChild(nextButton);

            let index = 0;
            let startX = 0;
            let startY = 0;
            let deltaX = 0;
            let deltaY = 0;

            function render(next) {
                index = Math.max(0, Math.min(slides.length - 1, next));
                track.style.transform = 'translateX(' + (-index * 100) + '%)';

                dots.forEach(function (dot, dotIndex) {
                    const active = dotIndex === index;
                    dot.classList.toggle('is-active', active);
                    dot.setAttribute('aria-current', active ? 'true' : 'false');
                });

                prevButton.disabled = index === 0;
                nextButton.disabled = index === slides.length - 1;
            }

            dots.forEach(function (dot, dotIndex) {
                dot.addEventListener('click', function () {
                    render(dotIndex);
                });
            });

            prevButton.addEventListener('click', function () {
                render(index - 1);
            });

            nextButton.addEventListener('click', function () {
                render(index + 1);
            });

            viewport.addEventListener('touchstart', function (event) {
                if (!event.touches.length) return;
                startX = event.touches[0].clientX;
                startY = event.touches[0].clientY;
                deltaX = 0;
                deltaY = 0;
            }, { passive: true });

            viewport.addEventListener('touchmove', function (event) {
                if (!event.touches.length) return;
                deltaX = event.touches[0].clientX - startX;
                deltaY = event.touches[0].clientY - startY;
            }, { passive: true });

            viewport.addEventListener('touchend', function () {
                if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
                    render(index + (deltaX < 0 ? 1 : -1));
                }
            });

            render(0);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPLPPhilosophyStorySliders, { once: true });
    } else {
        initPLPPhilosophyStorySliders();
    }
})();

